function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.32 2.17a.556.556 0 010 .821L5.99 8l5.328 5.009a.556.556 0 010 .82.646.646 0 01-.873 0L4.68 8.412a.556.556 0 010-.822l5.765-5.419a.646.646 0 01.873 0z",
  fill: "#2D2D2D"
});
function SvgChevronizquierda(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}
export default __webpack_public_path__ + "/img/Chevron izquierda.svg";
export { SvgChevronizquierda as ReactComponent };